import { MouseEventHandler } from 'react';

import { StyledResumeIcon } from './ResumeIcon.styled';

type ResumeIconProps = { onClick: MouseEventHandler };

export const ResumeIcon = (props: ResumeIconProps): JSX.Element => (
   <StyledResumeIcon onClick={props.onClick}>
      <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
         <rect x='1' y='1' width='30' height='30' rx='15' stroke='#589AE9' strokeWidth='2' />
         <circle cx='16' cy='16' r='7' fill='#C96262' />
      </svg>
   </StyledResumeIcon>
);
